const MARKETING_REFERRAL_COOKIE = 'ap_marketing_referral';
const MARKETING_REFERRAL_MAX_AGE = 60 * 60 * 24 * 30; // 30 days

const normalizeMarketingToken = (value?: string | null): string =>
    String(value ?? '')
        .trim()
        .toUpperCase();

export const setMarketingReferralCookie = (token: string): boolean => {
    const normalized = normalizeMarketingToken(token);

    if (!/^[A-Z0-9]{1,20}$/.test(normalized)) return false;

    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${MARKETING_REFERRAL_COOKIE}=${encodeURIComponent(
        normalized,
    )}; Path=/; Max-Age=${MARKETING_REFERRAL_MAX_AGE}; SameSite=Lax${secure}`;

    return true;
};

export const getMarketingReferralCookie = (): string | undefined => {
    const prefix = `${MARKETING_REFERRAL_COOKIE}=`;
    const cookie = document.cookie
        .split(';')
        .map((item) => item.trim())
        .find((item) => item.startsWith(prefix));

    if (!cookie) return undefined;

    const value = normalizeMarketingToken(
        decodeURIComponent(cookie.substring(prefix.length)),
    );

    return /^[A-Z0-9]{1,20}$/.test(value) ? value : undefined;
};

export const clearMarketingReferralCookie = (): void => {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${MARKETING_REFERRAL_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax${secure}`;
};
